<template>
  <div class="empty-helper">
    <InitialAvatarIcon
      class="empty-helper__icon"
      :icon="helperData.icon"
      size="large"
    />
    <BaseText>{{ helperData.text }}</BaseText>
    <BaseText v-if="helperData.value" :color="NebraskaColors.elementPrimary">
      {{ helperData.value }}
    </BaseText>
    <ButtonSecondary
      v-if="helperData.buttonLabel"
      class="empty-helper__button"
      :label="helperData.buttonLabel"
      @click="$emit('click')"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  InitialAvatarIcon,
  BaseText,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';

interface IHelperData {
  icon: string;
  text: string;
  value: string;
  buttonLabel: string;
}

interface EmitEvents {
  (event: 'click'): void;
}
defineEmits<EmitEvents>();

interface Props {
  type: string;
  searchValue: string;
  filtersCount: number;
}
const props = defineProps<Props>();

const helperData = computed(() => {
  const data: { [key: string]: IHelperData } = {
    search: {
      icon: 'EE0150',
      text: 'Não encontramos resultados para a busca',
      value: `"${props.searchValue}"`,
      buttonLabel: 'Limpar busca'
    },
    filter: {
      icon: 'EE0050',
      text: `Não encontramos resultados para ${
        props.filtersCount > 1 ? 'os' : ''
      }`,
      value: `"${props.filtersCount} ${
        props.filtersCount > 1 ? 'filtros aplicados' : 'filtro aplicado'
      }"`,
      buttonLabel: 'Limpar filtros'
    },
    empty: {
      icon: 'BA0011',
      text: 'Não há produtos no momento',
      value: '',
      buttonLabel: ''
    }
  };

  return data[props.type];
});
</script>

<style lang="less" scoped>
.empty-helper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &__icon {
    margin-bottom: @size-spacing-x500;
  }

  &__button {
    margin-top: @size-spacing-x500;
  }
}
</style>
